/**
 * L2-R5: moved verbatim from @shared/utils/helpers/clean-object.
 * That host path is now a re-export shim of this file.
 */
/**
 * compare with null & undefined only
 */
const checkNullsOnly = value => value != null;
const isEmptyObject = (data: any) => isObject(data) && Object.keys(data).length === 0;
/**
 * it returns truthy values (not null, undefined, 0, false, '', etc)
 * @param value
 */
export const valuePresence = value => {
  const isNullOrEmpty = value == null || `${value}`.trim() === '';
  return !isNullOrEmpty && !isEmptyObject(value);
};
export function isObject(target) {
  return target !== null && typeof target === 'object' && !Array.isArray(target) && !(target instanceof Date);
}
/**
 * Remove any undefined or null value attributes in an object
 * @param data
 * @param checkPresence
 */
export const cleanObject = <T>(data: T, checkPresence = false): T =>
  Object.entries(data)
    .filter(([, value]) => (checkPresence ? valuePresence(value) : checkNullsOnly(value)))
    .map(([key, val]) => {
      let nextVal = val;
      if (Array.isArray(val)) {
        const cleanedElements = val.filter(Boolean).map(x => cleanObject(x, checkPresence));
        nextVal = cleanedElements.filter(value => (checkPresence ? valuePresence(value) : checkNullsOnly(value)));
      } else if (isObject(val)) {
        nextVal = cleanObject(val, checkPresence);
      }
      return [key, nextVal];
    })
    .reduce((acc, [key, val]) => ({ ...acc, [key]: val }), {}) as T;
// TODO replace all other `cleanObject` fns implementations
// in composers files
/* TODO: merge cleanObject2 into cleanObject
  DEVELOPER NOTE:
 * Since changes on this function were applied in a hotfix, opted to duplicate the current version of it to
  ensure we are not breaking existing usages of cleanObject since cleanObject could potentially break existing
  code by being able to return null objects if an object is empty whereas clean object just returns an empty one.
  As TECH DEBT we need to replace cleanObject functionality with cleanObject2 targeting to October release
 */
/**
 * Next version of cleanObject
 * @param data
 * @param checkPresence
 * @returns
 */
export const cleanObject2 = <T>(data: T): T => {
  if (!isObject(data)) return data;
  const nextData = Object.entries(data)
    .map(([key, val]) => {
      let nextVal = val;
      if (Array.isArray(val)) {
        const cleanedElements = val.map(x => cleanObject2(x)).filter(Boolean);
        nextVal = cleanedElements.filter(value => valuePresence(value));
      } else if (isObject(val)) {
        nextVal = cleanObject2(val);
      }
      return [key, nextVal];
    })
    .filter(([, value]) => valuePresence(value))
    .reduce((acc, [key, val]) => ({ ...acc, [key]: val }), {}) as T;
  return !isEmptyObject(nextData) ? nextData : null;
};
